import {
  type ApiRoleStrategy,
  ROLES,
  api,
  useGetSectorDataref,
  useGetUppDataref,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useAssignementReferential = () => {
  const { sectorReferential: sectors, sectorDatarefIsLoading } =
    useGetSectorDataref()
  const { uppReferential: upps, uppDatarefIsLoading } = useGetUppDataref()
  const { queryKey, endpoint } = useRoleConf(createAdherentDataref)

  const { data: cerpBranch = [], isLoading: cerpBranchIsLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<CerpBranchDataReferential>(endpoint),
    select: (raw) => raw.cerpBranches,
  })

  return {
    referential: { sectors, upps, cerpBranch },
    referentialIsLoading:
      sectorDatarefIsLoading || uppDatarefIsLoading || cerpBranchIsLoading,
  }
}

interface CerpBranchDataReferential {
  cerpBranches: {
    code: string
    label: string
  }[]
}

const adhConf = {
  queryKey: ["adherent", "referential", "my-adherent"],
  endpoint: "/api/adherents/referential/my-adherent",
}
const createAdherentDataref: ApiRoleStrategy = {
  [ROLES.ADMIN]: {
    queryKey: ["adherent", "referential", "update"],
    endpoint: "/api/adherents/referential/update",
  },
  [ROLES.ADHERENT_HOLDER]: adhConf,
  [ROLES.ADHERENT_TEAM]: adhConf,
}
